import React from 'react';
import Form from 'src/components/form/Form';
import { Button, Checkbox, Icon, Modal } from 'semantic-ui-react';
import { habeasData } from 'src/components/helpers/habeasData';
import { CONTACT_OPTIONS, DISCIPLESHIP_OPTIONS } from '../constants';
import FieldLabel from './FieldLabel';
import OptionSelectList from 'src/components/OptionSelectList';
import StepProgress from './StepProgress';
import { FlowHeader, CalculatedAgePill } from '../styles';
import { shouldLockGuestIdentity } from 'src/components/helpers/guests/guestIdentity';

const LAW_1581_URL = 'https://www.funcionpublica.gov.co/eva/gestornormativo/norma.php?i=49981';

const NewMembersPersonalForm = ({
  Attendant,
  categoryInfo,
  errorInputs,
  hasErrors,
  sending,
  handleInputs,
  selectHandle,
  setOption,
  toggleHabeas,
  setAttendant,
  setErrorInputs,
  onGuestUpdated,
}) => {
  const [habeasModalOpen, setHabeasModalOpen] = React.useState(false);
  const alreadySubmitted = Boolean(Attendant.alreadySubmitted);

  const categoryText =
    categoryInfo?.activityLabel || categoryInfo?.categoryLabel
      ? `${categoryInfo.age} años • ${categoryInfo.activityLabel || categoryInfo.categoryLabel}`
      : categoryInfo?.age != null
      ? `${categoryInfo.age} años`
      : null;

  return (
    <>
      <StepProgress currentStepId="form" />

      <FlowHeader>
        {alreadySubmitted ? (
          <>
            <h1>¡Gracias{Attendant.name ? ` ${Attendant.name}` : ''} por haberte registrado!</h1>
            <p className="flow-intro">
              Ya respondiste este formulario en los últimos 6 meses. En el siguiente paso te
              llevaremos a elegir un grupo de discipulado.
            </p>
          </>
        ) : (
          <>
            <h1>
              ¡Bienvenid{Attendant.gender === 'Femenino' ? 'a' : 'o'} {Attendant.name || ''} a Casa!
            </h1>
            <p className="flow-intro">
              Nos alegra mucho tu decisión de seguir a Jesús. Completa tus datos para acompañarte en
              este camino.
            </p>
          </>
        )}
      </FlowHeader>

      {hasErrors && !shouldLockGuestIdentity(Attendant) && (
        <p className="form-errors">Por favor verifica los campos marcados.</p>
      )}

      <Form
        showBirthdate
        showGender
        showCivil
        showEmail={false}
        Attendant={Attendant}
        handleInputs={handleInputs}
        errorInputs={errorInputs}
        setAttendant={setAttendant}
        setErrorInputs={setErrorInputs}
        onGuestUpdated={onGuestUpdated}
      />

      {!alreadySubmitted && (
        <>
          <div className="form-section">
            <FieldLabel required>¿Cómo prefieres que te contactemos?</FieldLabel>
            <OptionSelectList
              options={CONTACT_OPTIONS}
              value={Attendant.preferredContact}
              onChange={(next) => setOption('preferredContact', next)}
              error={errorInputs.preferredContact}
              indicator="radio"
            />
          </div>

          <div className="form-section">
            <FieldLabel required>¿Te gustaría unirte a un grupo de discipulado?</FieldLabel>
            <OptionSelectList
              options={DISCIPLESHIP_OPTIONS}
              value={Attendant.interestedGroup}
              onChange={(next) => setOption('interestedGroup', next)}
              error={errorInputs.interestedGroup}
              indicator="none"
              stackOnTablet
            />
          </div>
        </>
      )}

      {categoryText && (alreadySubmitted || Attendant.interestedGroup === 'Sí') && (
        <CalculatedAgePill>
          <span className="age-label">Categoria calculada:</span>
          <span className="age-value">{categoryText}</span>
        </CalculatedAgePill>
      )}

      {!alreadySubmitted && (
        <div className={`legal ${errorInputs.habeasDataAccepted ? 'error' : ''}`}>
          <div className="legal-header">
            <Checkbox
              checked={Boolean(Attendant.habeasDataAccepted)}
              onChange={toggleHabeas}
              label="Autorización de tratamiento de datos personales*"
            />
          </div>
          <p className="legal-text">
            Al hacer clic en continuar, aceptas nuestra{' '}
            <a
              href="#politica-tratamiento-datos"
              onClick={(e) => {
                e.preventDefault();
                setHabeasModalOpen(true);
              }}
            >
              Política de Tratamiento de Datos Personales
            </a>{' '}
            de acuerdo con la{' '}
            <a href={LAW_1581_URL} target="_blank" rel="noreferrer">
              Ley 1581 de 2012
            </a>
            .
          </p>
        </div>
      )}

      <Modal
        open={habeasModalOpen}
        onClose={() => setHabeasModalOpen(false)}
        size="small"
        closeIcon
      >
        <Modal.Header>Política de Tratamiento de Datos Personales</Modal.Header>
        <Modal.Content scrolling>{habeasData}</Modal.Content>
        <Modal.Actions>
          <Button primary type="button" onClick={() => setHabeasModalOpen(false)}>
            Entendido
          </Button>
        </Modal.Actions>
      </Modal>

      <div className="submit-actions">
        <Button type="submit" primary disabled={sending} loading={sending}>
          {alreadySubmitted ? (
            <>
              Ir a elegir grupo <Icon name="chevron right" />
            </>
          ) : (
            <>
              Continuar <Icon name="chevron right" />
            </>
          )}
        </Button>
      </div>
    </>
  );
};

export default NewMembersPersonalForm;
